<div class="flex flex-column gap-3">
    @if(sendSignalForm.length) {
    <div class="pt-2">
        <form (submit)="delegateCases()">
            <p-table styleClass="radius-md alpha-border-1 overflow-hidden" [value]="sendSignalForm">
                <!-- table header start -->
                <ng-template pTemplate="header">
                    <tr class="text-sm">
                        <th class="col-3">{{"default-cm-cid" | translate : "CID"}}</th>
                        <th class="col-3">{{"default-cm-piid" | translate : "PIID"}}</th>
                        <th class="col-3">{{"default-cm-signalName" | translate : "Signal Name"}}</th>
                        <th class="col-3">{{"default-cm-variables" | translate : "Variables"}}</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-case let-rowIndex="rowIndex">
                    <tr class="text-normal text-md">
                        <td>{{ case.cid }}</td>
                        <td>{{ case.piid }}</td>
                        <td>{{ case.signalName }}</td>
                        <td>
                            <div class="flex flex-column">
                                <input pInputText [formControl]="case.variables" />
                                @if(!case.variables.valid) {
                                <span class="text-sm text-red-700">Please enter a valid JSON object</span>
                                }
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <!-- table body end -->
            </p-table>
            <div class="flex justify-content-end pt-3">
                <p-button
                    styleClass="px-3 text-base"
                    type="submit"
                    label="{{ 'default-cm-sendSignal' | translate : 'Send Signal' }}"
                    [disabled]="isInvalid()"
                ></p-button>
            </div>
        </form>
    </div>
    }
</div>
